"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateFullNameFieldValue = exports.getFullNameFieldEmptyValue = void 0;
const full_name_1 = require("../../../utils/full-name");
const getFullNameFieldEmptyValue = () => {
    return {
        title: "",
        first_name: "",
        middle_name: "",
        last_name: "",
        sys_root: "",
    };
};
exports.getFullNameFieldEmptyValue = getFullNameFieldEmptyValue;
const generateFullNameFieldValue = (field, value) => {
    const sysRoot = (0, full_name_1.formatFullName)(field, value);
    return { ...(0, exports.getFullNameFieldEmptyValue)(), ...value, sys_root: sysRoot };
};
exports.generateFullNameFieldValue = generateFullNameFieldValue;
